import React from 'react';
import { Star, Clock, Award } from 'lucide-react';

const benefits = [
  {
    icon: Clock,
    title: 'Horários Flexíveis',
    description: 'Trabalhe nos horários que melhor se adequam à sua rotina'
  },
  {
    icon: Star,
    title: 'Ganhos Atrativos',
    description: 'Excelente remuneração por consulta e bônus por performance'
  },
  {
    icon: Award,
    title: 'Desenvolvimento',
    description: 'Treinamentos e suporte para crescimento profissional'
  }
];

export const WorkBenefits: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {benefits.map((benefit, index) => {
        const Icon = benefit.icon;
        return (
          <div 
            key={index}
            className="bg-white/10 backdrop-blur-lg rounded-lg p-6"
          >
            <Icon className="w-8 h-8 text-purple-300 mb-4" />
            <h3 className="text-lg font-medium text-purple-200 mb-2">
              {benefit.title}
            </h3>
            <p className="text-purple-200/70">
              {benefit.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};